/*
 * Copyright (C) 2014 Spanning Cloud Apps LLC.  All rights reserved.
 */
/**
 * Service module for audit view service.
 */
'use strict';

angular
  .module('services.auditview', [])
  /**
   * A factory with common audit view utilities.
   */
  .factory('AuditViewFactory', function ($filter, AUDIT_VIEW_TYPES) {
    return {
      /**
       * Returns the audit type string
       * for the audit event.
       *
       * @param {type} auditType - The audit type.
       * @param {data} audit - The audit event object.
       * @returns {string} - A formatted audit event string.
       */
      getAuditViewType: function (auditType, data) {
        var auditViewType = AUDIT_VIEW_TYPES[auditType],
          auditEventStr;
        if (auditViewType === AUDIT_VIEW_TYPES.CHATTER_NOTIFICATION_SETTINGS_CHANGED) {
          if (data.newValue.enabled) {
            auditEventStr = $filter('i18n')('CHATTER_NOTIFICATION_SETTINGS_CHANGED_ENABLED', [
              $filter('i18n')(data.newValue.notificationType).toLowerCase(),
              data.newValue.notificationName
            ]);
          } else {
            auditEventStr = $filter('i18n')('CHATTER_NOTIFICATION_SETTINGS_CHANGED_DISABLED');
          }
        } else if (auditViewType === AUDIT_VIEW_TYPES.EMAIL_NOTIFICATION_SETTINGS_CHANGED) {
          if (data.newValue.frequency === 'NONE') {
            auditEventStr = $filter('i18n')('EMAIL_NOTIFICATION_SETTINGS_CHANGED_DISABLED');
          } else {
            auditEventStr = $filter('i18n')('EMAIL_NOTIFICATION_SETTINGS_CHANGED_ENABLED', [
              $filter('i18n')(data.newValue.frequency),
              data.newValue.address
            ]);
          }
        } else if (auditViewType === AUDIT_VIEW_TYPES.BACKUP_START_TIME_CHANGED) {
          if (data.oldValue && data.newValue) {
            auditEventStr = $filter('i18n')('BACKUP_START_TIME_CHANGED', [
              moment().utc().hour(data.oldValue).local().format('h a z'),
              moment().utc().hour(data.newValue).local().format('h a z')
            ]);
          } else if (!data.newValue) {
            auditEventStr = $filter('i18n')('BACKUP_START_TIME_DISABLED');
          } else {
            auditEventStr = $filter('i18n')('BACKUP_START_TIME_SET', [
              moment().utc().hour(data.newValue).local().format('h a z')
            ]);
          }
        } else if (auditViewType === AUDIT_VIEW_TYPES.ADDED_OBJECT_TYPE_EXCLUSION) {
          if (data.newValue) {
            auditEventStr = $filter('i18n')('ADDED_OBJECT_TYPE_EXCLUSION', data.newValue);
          } else {
            auditEventStr = $filter('i18n')('ADDED_OBJECT_TYPE_EXCLUSION', 0);
          }
        } else if (auditViewType === AUDIT_VIEW_TYPES.DELETED_OBJECT_TYPE_EXCLUSION) {
          if (Array.isArray(data.deletedValue) && data.deletedValue.length > 0) {
            auditEventStr = $filter('i18n')('DELETED_OBJECT_TYPE_EXCLUSION', data.deletedValue.join(', '));
          } else {
            auditEventStr = $filter('i18n')('DELETED_OBJECT_TYPE_EXCLUSION', 0);
          }
        } else {
          auditEventStr = $filter('i18n')('AUDIT_VIEW_TYPE_NOT_FOUND');
        }

        return auditEventStr;
      },
      /**
       * Returns the user facing audit event message for service account changes
       *
       * @param {Object} audit - The audit event.
       * @returns {string} - A formatted audit event string.
       */
      getNewServiceAccountUserName: function (audit) {
        var userName, auditEventStr;

        //initially we did not store the old/new values in the audit event table
        //we have to support displaying the username whether it was stored in the data column or if it was
        //store on the audit event itself (legacy)
        if (audit.data && audit.data.newValue) {
          userName = audit.data.newValue.userName;
        } else {
          userName = audit.username;
        }

        //inject the username into our resource string
        auditEventStr = $filter('i18n')('SERVICE_ACCOUNT_CHANGED', [userName]);
        return auditEventStr;
      },
      /**
       * Returns the user facing audit event message when the KMS feature is toggled on/off for an org.
       *
       * @param {Object} audit - The audit event.
       *
       * @returns {String} - A formatted audit event string.
       */
      getKmsEnabledDisabled: function (audit) {
        var auditEventStr;

        if (audit.data.newValue) {
          auditEventStr = $filter('i18n')('USE_KMS_CHANGED_ENABLED');
        } else {
          auditEventStr = $filter('i18n')('USE_KMS_CHANGED_DISABLED');
        }

        return auditEventStr;
      }
    };
  });
